<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      rowKey="enterpriseId"
      :itemNames="['name_1','name_2','name_3']"
      :columns="getColumns()"
      :col="4"
      :queryParams="queryParams"
      :requestPromise="getListPromise"
      :showResetButton="true"
      @reset="resetEvent"
    >
      <a-form-item slot="name_1" label="企业名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.enterpriseName" :maxLength="20" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="name_2" label="联系人" v-bind="searchItemLayout">
        <a-input v-model="queryParams.contactName" :maxLength="20" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="name_3" label="手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.mobile" :maxLength="11" placeholder="请输入"/>
      </a-form-item>
      <a-button slot="operation" style="margin: 0 0 20px 20px;" type="primary" @click="editEvent('add')">
        创建企业
      </a-button>
      <span slot="enterpriseName" slot-scope="rowItem">
        <a-tooltip placement="topLeft">
          <template slot="title">
            {{ rowItem.record.enterpriseName }}
          </template>
          <div class="pro_title">
            {{ rowItem.record.enterpriseName }}
          </div>
        </a-tooltip>
      </span>
      <span slot="contactName" slot-scope="rowItem">
        <a-tooltip placement="topLeft">
          <template slot="title">
            {{ rowItem.record.contactName }} ( {{ rowItem.record.mobile }} )
          </template>
          <div class="pro_title">
            {{ rowItem.record.contactName }} ( {{ rowItem.record.mobile }} )
          </div>
        </a-tooltip>
      </span>
      <span slot="action" slot-scope="rowItem">
        <a @click="editEvent('edit',rowItem.record)">编辑</a>
        <a-divider type="vertical"/>
        <a-popconfirm :title="'是否要'+(rowItem.record.status === 1 ? '禁用' : '启用')+'当前企业'"
                      @confirm="updateStatus(rowItem.record)">
          <a>{{ rowItem.record.status === 1 ? '禁用' : '启用' }}</a>
        </a-popconfirm>
        <a-divider type="vertical"/>
        <a @click="toStaff(rowItem.record)">员工管理</a>
      </span>
    </search-page-view>

    <a-modal
      title='企业信息'
      :visible='modalVisible'
      :confirmLoading='submitLoading'
      width="480px"
      @ok="submitEvent"
      @cancel="cancelEvent"
    >
      <a-form-model
        :model="ruleForm"
        ref="ruleForm"
        :rules="tabRule"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="企业名称" prop="enterpriseName">
          <a-input
            placeholder="请输入"
            v-model="ruleForm.enterpriseName"
            :maxLength="20"
            :disabled="isEdit"
          />
        </a-form-model-item>
        <a-form-model-item label="联系人" prop="contactName">
          <a-input
            placeholder="请输入"
            v-model="ruleForm.contactName"
            :maxLength="20"
          />
        </a-form-model-item>
        <a-form-model-item label="手机号码" prop="mobile">
          <a-input
            placeholder="请输入"
            v-model.number="ruleForm.mobile"
            :maxLength="11"
          />
        </a-form-model-item>
        <a-form-model-item label="企业邮箱" prop="enterpriseEmail">
          <a-input
            placeholder="请输入"
            v-model="ruleForm.enterpriseEmail"
            :maxLength="50"
          />
        </a-form-model-item>
        <a-form-model-item label="企业地址" prop="enterpriseAddress">
          <a-input
            placeholder="请输入"
            v-model="ruleForm.enterpriseAddress"
            :maxLength="200"
          />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-radio-group v-model="ruleForm.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="2">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import WelfareMallMixins from '@/views/service/serviceProvider/welfareMall/mixins/WelfareMallMixins'
import Vue from 'vue'

export default {
  name: 'WelfareMallEnterprise',
  mixins: [WelfareMallMixins],
  data() {
    return {
      queryParams: {},
      searchItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      modalVisible: false,
      submitLoading: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      ruleForm: {
        status: 1
      },
      tabRule: {
        enterpriseName: [
          { required: true, message: '请输入企业名称', trigger: ['blur', 'change'] }
        ],
        contactName: [
          { required: true, message: '请输入联系人', trigger: ['blur', 'change'] }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }
        ],
        enterpriseEmail: [
          { required: true, message: '请输入企业邮箱', trigger: ['blur', 'change'] },
          {
            pattern: /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/,
            message: '邮箱格式不正确',
            trigger: ['blur', 'change']
          }
        ],
        enterpriseAddress: [
          { required: true, message: '请输入企业地址', trigger: ['blur', 'change'] }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: ['blur', 'change'] }
        ]
      },
      isEdit: false // 是否编辑
    }
  },
  methods: {
    getListPromise(params) {
      params.merchantId = this.merchantId
      params.platformId = this.platformId
      params.mobile = params.mobile || undefined
      return this.getHttpServices().getServerApiService().post('welfare/getEnterpriseList', params)
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'enterpriseId'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          scopedSlots: { customRender: 'enterpriseName' }
        },
        {
          title: '联系人',
          dataIndex: 'contactName',
          scopedSlots: { customRender: 'contactName' },
          width: '200px'
        },
        {
          title: '员工数',
          dataIndex: 'employeeCount'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    resetEvent() {
      this.queryParams = {}
      setTimeout(() => {
        this.$refs.pageList.refresh(true)
      }, 200)
    },
    async editEvent(type, record) {
      if (type === 'add') {
        this.isEdit = false
        this.ruleForm = { status: 1 }
      } else {
        this.isEdit = true
        this.ruleForm = await this.getEnterpriseDetail(record)
      }
      this.modalVisible = true
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate()
      })
    },
    getEnterpriseDetail(record) {
      return new Promise(resolve => {
        this.getHttpServices().getServerApiService().post('welfare/enterpriseDetail', {
          enterpriseId: record.enterpriseId,
          merchantId: this.merchantId,
          platformId: this.platformId
        }).then(res => {
          resolve(res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      })
    },
    cancelEvent() {
      this.modalVisible = false
    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateRequest()
        } else {
          this.$message.error('请完善必要的信息')
        }
      })
    },
    updateRequest() {
      if (!this.submitLoading) {
        this.submitLoading = true
        this.getHttpServices().getServerApiService().post('welfare/saveEnterprise', {
          ...this.ruleForm,
          merchantId: this.merchantId,
          platformId: this.platformId
        }).then(res => {
          this.$message.success('保存成功')
          this.cancelEvent()
          if (this.ruleForm.enterpriseId) {
            this.$refs.pageList.refresh()
          } else {
            this.$refs.pageList.refresh(true)
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    },
    updateStatus(record) { // 启用/禁用
      let tips = record.status === 1 ? '禁用成功' : '启用成功'
      this.getHttpServices().getServerApiService().post('welfare/updateEnterpriseStatus', {
        enterpriseId: record.enterpriseId,
        merchantId: this.merchantId,
        platformId: this.platformId,
        status: record.status === 1 ? 2 : 1
      }).then(res => {
        this.$message.success(tips)
        this.$refs.pageList.refresh()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    toStaff(record) { // 员工管理
      Vue.ls.set('enterpriseId', record.enterpriseId)
      Vue.ls.set('enterpriseName', record.enterpriseName)
      this.openNewPage('WelfareMallStaff')
    }
  }
}
</script>

<style lang="less" scoped>
.pro_title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
</style>

